var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColAudioSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 19,
    viewBox: "0 0 4 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.98619 0.287163H1.73336C1.03808 0.287163 0.474442 0.738662 0.474442 1.29562V17.7065C0.474442 18.2634 1.03808 18.7149 1.73336 18.7149H1.98619C2.68147 18.7149 3.24511 18.2634 3.24511 17.7065V1.29562C3.24511 0.738662 2.68147 0.287163 1.98619 0.287163Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColAudioSm);
export default __webpack_public_path__ + "static/media/col_audio_sm.4d5ef39040340616ff7375fd0dbea64e.svg";
export { ForwardRef as ReactComponent };